// GENERATED by scripts/generate-themes-page.ts from the house theme supply and src/rendering/themes/generated/host-variables.json (CO 680 Phase 2b). Do not edit by hand.
// Regenerate: pnpm tsx scripts/generate-themes-page.ts

export const THEMES_PAGE_DATA = {
  "co": "680",
  "generated_from": "houseThemeEntries() + src/rendering/themes/generated/host-variables.json",
  "roles": [
    "surface",
    "on-surface",
    "primary",
    "accent",
    "muted",
    "border"
  ],
  "themes": [
    {
      "ref": "paper@1.0.0",
      "id": "paper",
      "version": "1.0.0",
      "sha16": "2b89e215891f4aef",
      "glass": false,
      "swatches": {
        "light/standard": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#4338CA",
          "accent": "#0F766E",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "light/more": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#3730A3",
          "accent": "#115E59",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "dark/standard": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#818CF8",
          "accent": "#14B8A6",
          "muted": "#15181F",
          "border": "#23272F"
        },
        "dark/more": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#A5B4FC",
          "accent": "#2DD4BF",
          "muted": "#15181F",
          "border": "#23272F"
        }
      }
    },
    {
      "ref": "ink@1.0.0",
      "id": "ink",
      "version": "1.0.0",
      "sha16": "3cfa32a40b6adbfe",
      "glass": false,
      "swatches": {
        "light/standard": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#4338CA",
          "accent": "#0F766E",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "light/more": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#3730A3",
          "accent": "#115E59",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "dark/standard": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#818CF8",
          "accent": "#14B8A6",
          "muted": "#15181F",
          "border": "#23272F"
        },
        "dark/more": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#A5B4FC",
          "accent": "#2DD4BF",
          "muted": "#15181F",
          "border": "#23272F"
        }
      }
    },
    {
      "ref": "field@1.0.0",
      "id": "field",
      "version": "1.0.0",
      "sha16": "da9e97c3674d9ec4",
      "glass": false,
      "swatches": {
        "light/standard": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#0F766E",
          "accent": "#4338CA",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "light/more": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#115E59",
          "accent": "#3730A3",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "dark/standard": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#14B8A6",
          "accent": "#818CF8",
          "muted": "#15181F",
          "border": "#23272F"
        },
        "dark/more": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#2DD4BF",
          "accent": "#A5B4FC",
          "muted": "#15181F",
          "border": "#23272F"
        }
      }
    },
    {
      "ref": "signal@1.0.0",
      "id": "signal",
      "version": "1.0.0",
      "sha16": "e5dfed9a13dbe384",
      "glass": false,
      "swatches": {
        "light/standard": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#0F766E",
          "accent": "#4338CA",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "light/more": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#115E59",
          "accent": "#3730A3",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "dark/standard": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#14B8A6",
          "accent": "#818CF8",
          "muted": "#15181F",
          "border": "#23272F"
        },
        "dark/more": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#2DD4BF",
          "accent": "#A5B4FC",
          "muted": "#15181F",
          "border": "#23272F"
        }
      }
    },
    {
      "ref": "material@1.0.0",
      "id": "material",
      "version": "1.0.0",
      "sha16": "c2d80ea82d4d76ef",
      "glass": false,
      "swatches": {
        "light/standard": {
          "surface": "#FCF8FF",
          "on-surface": "#1C1B21",
          "primary": "#5A5891",
          "accent": "#7A5368",
          "muted": "#EAE7EF",
          "border": "#C8C5D0"
        },
        "light/more": {
          "surface": "#FCF8FF",
          "on-surface": "#000000",
          "primary": "#27255B",
          "accent": "#422134",
          "muted": "#D6D3DB",
          "border": "#494851"
        },
        "dark/standard": {
          "surface": "#131318",
          "on-surface": "#E5E1E9",
          "primary": "#C3C0FF",
          "accent": "#EAB9D1",
          "muted": "#2A292F",
          "border": "#47464F"
        },
        "dark/more": {
          "surface": "#131318",
          "on-surface": "#FFFFFF",
          "primary": "#F2EEFF",
          "accent": "#FFEBF2",
          "muted": "#3C3B41",
          "border": "#C4C1CC"
        }
      }
    },
    {
      "ref": "glass@1.1.0",
      "id": "glass",
      "version": "1.1.0",
      "sha16": "51cdc9cd59087bb7",
      "glass": true,
      "swatches": {
        "light/standard": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#4338CA",
          "accent": "#0F766E",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "light/more": {
          "surface": "#FBFAF7",
          "on-surface": "#0B0D12",
          "primary": "#3730A3",
          "accent": "#115E59",
          "muted": "#F2F0EA",
          "border": "#E5E2DA"
        },
        "dark/standard": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#818CF8",
          "accent": "#14B8A6",
          "muted": "#15181F",
          "border": "#23272F"
        },
        "dark/more": {
          "surface": "#0B0D12",
          "on-surface": "#FBFAF7",
          "primary": "#A5B4FC",
          "accent": "#2DD4BF",
          "muted": "#15181F",
          "border": "#23272F"
        }
      }
    }
  ]
} as const;
